export const DEMO_REQUEST_PATH = '/demo-request'

export interface DemoValueProp {
    id: string
    text: string
}

export const DEMO_VALUE_PROPS: DemoValueProp[] = [
    {id: 'catalog', text: 'Your Shopify catalog mapped to Nordstrom, Macy\'s, Target+, and more'},
    {id: 'ai', text: 'AI fills marketplace-specific attributes, imagery, and taxonomy fields'},
    {id: 'sync', text: 'Inventory, orders, and fulfillments stay in sync after launch'},
    {id: 'speed', text: '20-minute walkthrough — your products, not a slide deck'},
]

export const DEMO_TRUST_HEADLINE = 'Built for fashion brands selling on department stores and marketplaces'
